import {
  Button,
  Center,
  Flex,
  Heading,
  VStack,
  Select,
  FormControl,
  FormLabel,
} from '@reverb-ui/react';
import { ChevronRight, ArrowCornerDownLeft } from '@reverb-ui/icons-react';

import {useCallback, useContext, useState} from 'react';
import {UserConsolesContext, UserConsolesProvider} from "../../contexts/user-consoles";
import {useHistory} from "react-router-dom";
import {AuthContext} from "../../contexts/auth";
import {ConsoleType} from "../../@types/IAuth";

const ChooseConsole = () => {
  const [ url, setUrl ] = useState(null)
  const history = useHistory()
  const { logout, token } = useContext(AuthContext)

  const navigateToConsoleUrl = (url: string) => {
    setUrl(url)
    window.location.href = `${url}?Token=${token}`
  }

  const backToLogin = async () => {
    await logout()
    history.push("/login")
  }

  const formatConsoleOptions = useCallback((consoles: ConsoleType[]) => {
    return consoles
      .filter(({ name }) => !!name)
      .map(({ url, name }) => ({
        value: url,
        label: name
      }))
  }, [])

  return (
    <UserConsolesProvider>
      <UserConsolesContext.Consumer>
        {({ consoles, loadingConsoles }) => (
          <Center bg="white" flexDirection="column" borderRadius="2xl" padding={12}>
            <VStack spacing={16}>
              <VStack alignItems="start">
                <Heading
                  as="h1"
                  width="full"
                  fontFamily="manrope"
                  fontSize="5xl"
                  fontWeight="extrabold"
                >
                  Choose a console
                </Heading>
              </VStack>
              <FormControl id="consoles">
                <FormLabel>Console name</FormLabel>
                <Select
                  isDisabled={loadingConsoles}
                  name="consoles"
                  placeholder="Select a console"
                  onChange={({ value }) => setUrl(value)}
                  options={formatConsoleOptions(consoles)}
                />
              </FormControl>
              <VStack width="full" spacing={5}>
                <Flex width="full" justifyContent="center" className="flex-end">
                  <Button
                    size="lg"
                    p="4"
                    bg="blue.500"
                    isDisabled={!url}
                    color="white"
                    colorScheme="blue"
                    rightIcon={<ChevronRight color="white" />}
                    onClick={() => navigateToConsoleUrl(url)}
                  >
                    Enter
                  </Button>
                </Flex>
                <Button
                  onClick={backToLogin}
                  leftIcon={<ArrowCornerDownLeft color="blue.500" />}
                  variant="ghost"
                  color="blue.500"
                >
                  Back to login
                </Button>
              </VStack>
            </VStack>
          </Center>
        )}
      </UserConsolesContext.Consumer>
    </UserConsolesProvider>
  );
};

export default ChooseConsole;
